import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { allowsPhcEntryWithoutSession } from "helper/phcPreviewAuthToken";

/**
 * Like PrivateRoute, but allows unauthenticated access to PHC when the URL is
 * onboarding preview with a valid `token` query (handled further in PhcNavigator).
 */
function PhcPrivateRoute({
  auth,
  component: Component,
  redirectTo = "/login",
  ...rest
}) {
  const location = useLocation();
  const allowed =
    auth?.isAuthenticated ||
    allowsPhcEntryWithoutSession(location.pathname, location.search);

  if (!allowed) {
    return <Redirect to={redirectTo} />;
  }

  return <Route {...rest} component={Component} />;
}

export default PhcPrivateRoute;
